<template>
  <div>
    <h3> Countdown to the end.</h3>
    <flip-countdown deadline="2020-09-26 14:00:00"></flip-countdown>
    <p></p>
    <div class="box">
      <h3>Max and Christina welcome you to our wedding website.</h3>
      <p v-if="!authenticated">Please sign in to RSVP. Or just play a game of solitaire the solitary times.</p>
      <p v-else>Welcome! Play a game, RSVP, view our registry or get some info.<br/> Whatever you're here for, we are happy to have you.</p>
      <button @click="$router.push('games')">Games</button>
      <div v-if="authenticated">
        <p></p>
        <h1>Hi {{ firstName }}!</h1>
        <button v-if="!rsvped" @click="$router.push('rsvp')">Create RSVP</button>
        <button v-if="rsvped" @click="$router.push('rsvp')">View RSVP</button>
        <button @click="$router.push('info')">Event Information</button>
        <button @click="$router.push('registry')">Wedding Registry</button>
        <button @click="logout">Logout</button>
      </div>
      <button @click="$router.push('faq')">FAQ</button>
      <button v-if="authenticated" @click="$router.push('live')">Live Stream<sup :style="{'color': 'red'}">NEW!</sup></button>
      <button v-if="!authenticated" @click="login">Login</button>
    </div>
  </div>
</template>

<script>
  import Firebase from '../firebase.js';
  import FlipCountdown from 'vue2-flip-countdown'

  export default {
    components: {
      FlipCountdown
    },
    data () {
      return {
        user: {
          loggedIn: false,
          data: {}
        },
        rsvped: false
      }
    },
    computed: {
      authenticated(){
        return this.user.loggedIn
      },
      firstName(){
        if (this.user.data.displayName) {
          return this.user.data.displayName.split(' ')[0]
        }
        return null
      }
    },
    methods: {
      login() {
        Firebase.login();
      },
      logout() {
        Firebase.logout()
      }
    },
    mounted: function() {
      Firebase.auth.onAuthStateChanged( user => {
        if (user) {
          this.user.loggedIn = true;
          this.user.data = user;
          this.rsvped = false;
          Firebase.db.ref('rsvp/' + this.user.data.uid).once('value').then((snapshot) => {
            if (snapshot.val()) {
              this.rsvped = true;
            }
          }).catch((err) => {console.log(err)});
        }
        else {
          this.user.loggedIn = false;
          this.user.data = {};
        }
      })
    }
    };
</script>

<style scoped>
</style>
